!function($, window) {
    let wordsToWriteArr;
    const hideRandomShapeInHero = () => {
        const $shapes = $(".js-shapes").find("div");
        setInterval((() => {
            $shapes.eq(function getRandomNumber(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
            }(0, $shapes.length)).addClass("is-hidden");
        }), 500), setInterval((() => {
            $shapes.removeClass("is-hidden");
        }), 1e3);
    }, heroTypeWritter = () => {
        $(".js-hero-typewritter").each((function() {
            let finalWords = [];
            const arrOfWords = $(this).data("words").split(","), typewriterEl = $(this).find("small");
            for (var i = 0; i < arrOfWords.length; i++) finalWords.push(arrOfWords[i]);
            const heroTypeWritter = new Typewriter(typewriterEl[0], {
                delay: 100,
                deleteSpeed: 100
            });
            let finalFirstWord = "experience|", finalSecondWord = "efront";
            finalWords.length >= 1 && (finalFirstWord = finalWords[0]), finalWords.length >= 2 && (finalSecondWord = finalWords[1]), 
            heroTypeWritter.typeString(finalFirstWord).callFunction((() => {
                $(this).addClass("hide");
            })).deleteAll().typeString(finalSecondWord).callFunction((() => {
                hideRandomShapeInHero();
            })).start();
        })), $(document).trigger("efr_decode_blocks");
    }, setWordsFromDataAttributes = () => {
        $(".js-hero-animation").find("li").each((function() {
            const wordsToWrite = $(this).data("words-print").split(",");
            wordsToWriteArr = wordsToWrite;
            for (let i = 0; i < wordsToWrite.length; i++) setTimeout((() => {
                $(this).find("strong").text(wordsToWrite[i]);
            }), 100 * i);
        }));
    };
    let imageInterval;
    !function heroAnimaton() {
        if (!$(".js-hero-animation").length) return;
        setWordsFromDataAttributes();
        const timeForHeroAnimationToFinish = 100 * (Math.max(...wordsToWriteArr.map((words => words.length))) - 3), $heroElementToAnimate = $(".js-hero-animation"), $shapes = $(".js-shapes");
        setTimeout((() => {
            $heroElementToAnimate.add($shapes).addClass("has-finished"), setTimeout((() => {
                $heroElementToAnimate.add($shapes).removeClass("has-finished"), heroTypeWritter();
            }), 80), setTimeout((() => {
                $shapes.addClass("secondary-animation"), $heroElementToAnimate.addClass("has-finished");
            }), 160), setTimeout((() => {
                $shapes.removeClass("secondary-animation"), $shapes.addClass("has-finished");
            }), 240), setTimeout((() => {
                $shapes.addClass("secondary-animation");
            }), 320);
        }), timeForHeroAnimationToFinish);
    }();
    const setClassNameToHoveredProject = $currentTarget => {
        const $projects = $(".js-hover-projects");
        $projects.each((function(e) {
            const $project = $(this), $media = $project.find(".media"), currentTargetClosestProject = $currentTarget.closest(".js-hover-projects")[0];
            currentTargetClosestProject == $project[0] ? ($media.hasClass("is-active") || ($currentProject => {
                const $projectsImages = $currentProject.find(".service__projects").find(".media");
                for (let i = 0; i < $projectsImages.length + 1; i++) imageInterval = setTimeout((() => {
                    $($projectsImages[i]).addClass("is-active");
                }), 200 * i);
            })($project), $project.addClass("is-hovered").siblings().removeClass("is-hovered")) : currentTargetClosestProject != $project[0] && $media.hasClass("is-active") && (clearInterval(imageInterval), 
            $projects.removeClass("is-hovered"), $media.removeClass("is-active"));
        }));
    };
    $(window).on("mousemove", (function(e) {
        setClassNameToHoveredProject($(e.target));
    })), $(".service__anchor").on("click", (function(e) {
        e.preventDefault();
        const $this = $(this);
        window.dataLayer = window.dataLayer || [], dataLayer.push({
            home_sector_name: $this.data("sector-name")
        }), window.location.href = $this.attr("href");
    }));
}(jQuery, window, document);